document.addEventListener('DOMContentLoaded', function() {

    setTimeout(() => {
        const loader = document.getElementById('page-loader');
        if (loader) loader.style.display = 'none';
    }, 2000)
    
    const dropdownLinks = document.querySelectorAll('.site-nav__link--has-dropdown');
    const dropdownLinksHeading = document.querySelectorAll('.h5 a.site-nav__dropdown-link');
    const dropdownLinksMobile = document.querySelectorAll('.mobile-nav__has-sublist a');
    const individual1 = document.querySelector('#Sublabel-pages-story-collections2'); 
    const individual2 = document.querySelector('#Sublabel-collections-all1'); 
    
    dropdownLinks.forEach(function(element) {
        element.setAttribute('href', 'javascript:void(0)');
    });
    
    dropdownLinksHeading.forEach(function(element) {
        element.setAttribute('href', 'javascript:void(0)');
    });

    dropdownLinksMobile.forEach(function(element) {
        element.setAttribute('href', 'javascript:void(0)');
    });

    if (individual1) individual1.setAttribute('href', 'javascript:void(0)');
    if (individual2) individual2.setAttribute('href', 'javascript:void(0)');


    // Get the selected metal and length
    document.addEventListener('variant:change', function(event) {
        const selectedVariant = event.detail.variant; 
        console.log('Selected variant ID:', selectedVariant.id);
        console.log('Selected variant price:', selectedVariant.price);
        console.log('Selected variant title:', selectedVariant.title);
        //console.log(selectedVariant)
    })

    // Custom Render JS
    const buttons = document.getElementsByClassName('openUploadsForm');
    for (const btn of buttons) {
        btn.addEventListener('click', function (e) {
            const order_type = btn.dataset.revision
            const submit_btn = document.getElementById('customUploadsForm')
            const render_order_type = document.getElementById('render_order_type')

            if(order_type == 'true'){
                submit_btn.textContent = 'Update Render Information'
                render_order_type.value = 'edit'
            }else{
                submit_btn.textContent = 'YES! GIMME THAT FREE RENDER!'
                render_order_type.value = 'add'
            }

            setTimeout(() => {
                const modal = document.getElementById('uploadsModal');
                modal.style.display = 'block';
            }, 100)
            
        });
    }

    document.getElementById('customUploadsForm').addEventListener('click', async function(e) {
        e.preventDefault();

        const uploadsEmail = document.getElementById('uploadsEmail').value.trim();
        const uploadsNotes = document.getElementById('uploadsNotes').value;
        const uploadsVariant = document.querySelector('input[name="uploadsVariant"]:checked');
        const uploadsFile = document.getElementById('uploadsFile').files[0];
        const statusDiv = document.getElementById('uploadsContentDiv');
            
        // if (!uploadsVariant.value && render_order_type.value == 'add') {
        //     statusDiv.textContent = 'Please select a product variant first!';
        //     statusDiv.style.color = 'red';
        //     return;
        // }

        // Basic validation
        if (!uploadsEmail || !uploadsFile || !uploadsVariant.value) {
            statusDiv.textContent = 'All fields are mandatory, please try again!';
            statusDiv.style.color = 'red';
            return;
        }

        const formData = new FormData();
        const render_order_type = document.getElementById('render_order_type')
        const render_order_id = document.getElementById('render_order_id')
        let ajax_url = ''

        if(render_order_type.value == 'add'){
            ajax_url = 'https://reloop.co/endpoint.php'
            formData.append('email', uploadsEmail); 
            formData.append('file', uploadsFile);
            formData.append('notes', uploadsNotes);
            formData.append('variant_id', String(uploadsVariant.value));

        }else if(render_order_type.value == 'edit'){
            ajax_url = 'https://reloop.co/reviseOrder.php'
            formData.append('file', uploadsFile);
            formData.append('order_id', String(render_order_id.value));
        }


        if(ajax_url != ''){
            try {
                // Disable submit button
                this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><radialGradient id="a9" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)"><stop offset="0" stop-color="#FF156D"></stop><stop offset=".3" stop-color="#FF156D" stop-opacity=".9"></stop><stop offset=".6" stop-color="#FF156D" stop-opacity=".6"></stop><stop offset=".8" stop-color="#FF156D" stop-opacity=".3"></stop><stop offset="1" stop-color="#FF156D" stop-opacity="0"></stop></radialGradient><circle transform-origin="center" fill="none" stroke="url(#a9)" stroke-width="15" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70"><animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform></circle><circle transform-origin="center" fill="none" opacity=".2" stroke="#FF156D" stroke-width="15" stroke-linecap="round" cx="100" cy="100" r="70"></circle></svg> Submitting...'
                this.disabled = true

                const response = await fetch(ajax_url, {
                    method: 'POST',
                    body: formData,
                    mode: 'cors'
                });

                if (response.ok) {
                    const responseData = await response.json();
                                        
                    document.getElementById('uploadsEmail').innerHTML = ' ';
                    document.getElementById('uploadsFile').innerHTML = ' ';
                    document.getElementById('uploadsNotes').innerHTML = ' ';
                    
                    setTimeout(() => {
                        if(render_order_type.value == 'edit'){
                            statusDiv.textContent = 'We have updated your request based on the new image, and our team will respond on '+uploadsEmail+' soon!';
                            statusDiv.style.color = 'green';
                            const modal2 = document.getElementById("uploadsModal"); modal2.style.display = "none";
                        }else{
                            statusDiv.textContent = 'We have received your request, and our team will respond on '+uploadsEmail+' soon!';
                            statusDiv.style.color = 'green';
                            window.location.href = responseData.redirect_url;
                        }
                    }, 2000)
                } else {
                statusDiv.textContent = 'Submission failed. Try again later.';
                statusDiv.style.color = 'red';
                }
            } catch (error) {
                console.error('Error submitting form:', error);
                statusDiv.textContent = 'An error occurred. Check the console.';
                statusDiv.style.color = 'red';
            }
        }
    });

    // Close the modal
    var currentModal = document.getElementById("uploadsModal");
    window.onclick = function(event) {
        if (event.target == currentModal) {
            currentModal.style.display = "none";
        }
    }

    window.onkeydown = function(event) {
        if (event.key === "Escape") {
            currentModal.style.display = "none";
        }
    }

    function getUrlParameter(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }

    const modal_id = getUrlParameter('modal');
    if(modal_id && modal_id == 'render-modal'){
        setTimeout(() => {
            currentModal.style.display = "block";
        }, 1000)
    }



    // Masonary
    setTimeout(() => {
        // $('.custom_lookbook_section .row').masonry({
        //     // options
        //     itemSelector: '.cls_item',
        //     columnWidth: 200
        // });

        var elem = document.querySelector('.custom_lookbook_section_row');
        var msnry = new Masonry( elem, {
            itemSelector: '.cls_item',
        });
    }, 1500)


    // Gifts page
    document.querySelector('#shopify-section-template--20024759517353__featured_collection_Lqebam .grid__item:nth-child(1) img').src = 'https://cdn.shopify.com/s/files/1/0412/9128/4636/files/Gemini_Generated_Image_8h0j6u8h0j6u8h0j.png?v=1775739520';
    document.querySelector('#shopify-section-template--20024759517353__featured_collection_Lqebam .grid__item:nth-child(2) img').src = 'https://cdn.shopify.com/s/files/1/0412/9128/4636/files/Gemini_Generated_Image_ec8df1ec8df1ec8d.png?v=1775739319';
    document.querySelector('#shopify-section-template--20024759517353__featured_collection_Lqebam .grid__item:nth-child(3) img').src = 'https://cdn.shopify.com/s/files/1/0412/9128/4636/files/4_4.png?v=1762179543';
    document.querySelector('#shopify-section-template--20024759517353__featured_collection_Lqebam .grid__item:nth-child(4) img').src = 'https://cdn.shopify.com/s/files/1/0412/9128/4636/files/Gemini_Generated_Image_4lzhxw4lzhxw4lzh.png?v=1775739319';

    document.querySelector('#shopify-section-template--20024759517353__featured_collections_a6E9zR .grid__item:nth-child(1) img').src = 'https://cdn.shopify.com/s/files/1/0412/9128/4636/files/josiederrick.sprout.2020-32.jpg?v=1760329338';
    document.querySelector('#shopify-section-template--20024759517353__featured_collections_a6E9zR .grid__item:nth-child(2) img').src = 'https://cdn.shopify.com/s/files/1/0412/9128/4636/files/1_2.png?v=1762343024';
    document.querySelector('#shopify-section-template--20024759517353__featured_collections_a6E9zR .grid__item:nth-child(3) img').src = 'https://cdn.shopify.com/s/files/1/0412/9128/4636/files/Screenshot_2025-10-02_at_2.45.54_PM.png?v=1760333066';
    document.querySelector('#shopify-section-template--20024759517353__featured_collections_a6E9zR .grid__item:nth-child(4) img').src = 'https://cdn.shopify.com/s/files/1/0412/9128/4636/files/9_1.png?v=1762179543';

});
